import React from 'react';
import '../styles/Loader.css';

export default function Loader({ message = "Cargando información..." }) {
  return (
    <div className="loader-container">
      <div className="loader-spinner"></div>
      <p className="loader-text">{message}</p>
    </div>
  );
}